// extracted by mini-css-extract-plugin
export default {"selectcustom":"PayrollPeriod_selectcustom__7AZSl","pagination":"PayrollPeriod_pagination__-QLA6"};